import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

import cookieImage from '../assets/cookie.png';
// import bizzy from '../assets/bizzy.jpg';

const BannerSystem = () => {
  const [cookieBannerVisible, setCookieBannerVisible] = useState(false);

  const notifications = [
    // {
    //   image: bizzy,
    //   description: 'Check out our new product - Bizzy Network',
    //   link: 'https://www.bizzynetwork.in',
    // },
  ];

  useEffect(() => {
    const accepted = localStorage.getItem('cookiesAccepted');
    if (!accepted) {
      setCookieBannerVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookiesAccepted', 'true');
    setCookieBannerVisible(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookiesAccepted', 'false');
    setCookieBannerVisible(false);
  };

  return (
    <div className="fixed bottom-4 right-0 left-0 md:left-auto md:right-4 px-4 md:px-0 z-50 flex flex-col gap-3 items-center md:items-end">
      {/* Notification Popups - Rendered above cookie banner */}
      {notifications.map((notification, index) => (
        <NotificationPopup
          key={index}
          image={notification.image}
          description={notification.description}
          link={notification.link}
        />
      ))}

      {/* Cookie Banner - Rendered at the bottom */}
      {cookieBannerVisible && (
        <div className="bg-white border border-black p-4 flex flex-col md:flex-row items-center space-x-0 md:space-x-4 space-y-4 md:space-y-0 animate-fadeIn w-full md:w-auto max-w-[350px]">
          <img src={cookieImage} alt="Cookie" className="w-12 h-12 animate-bounce" />
          <div className="flex-1">
            <p className="text-sm text-gray-800">
              We use cookies to improve your experience. By using our site, you consent to our use
              of cookies. For more details, read our{' '}
              <Link to="/privacy-policy" className="underline text-black hover:text-gray-600">
                Privacy Policy
              </Link>
              .
            </p>
            <div className="flex justify-end space-x-2 mt-2">
              <button
                onClick={handleReject}
                className="bg-white text-black hover:bg-black hover:text-white border border-black text-sm py-1 px-3 rounded transition"
              >
                Reject
              </button>
              <button
                onClick={handleAccept}
                className="bg-black text-white hover:bg-white hover:text-black border border-black text-sm py-1 px-3 rounded transition"
              >
                Accept
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const NotificationPopup = ({ image, description, link }) => {
  return (
    <a
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="bg-white border border-black p-2 flex items-center gap-2 hover:bg-gray-50 transition-colors w-full md:w-auto max-w-[350px] animate-fadeIn"
    >
      {image && <img src={image} alt="Notification" className="w-8 h-8 object-cover rounded" />}
      <p className="text-sm text-gray-800 flex-1">{description}</p>
    </a>
  );
};

export default BannerSystem;
